export default class GetResultadoPersonalById {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, idResultado) {
    return await this.#repository.getById(idPersonal, idResultado)
  }
}
